import { useSelector } from "react-redux";
import type { RootState } from "../../store";
import type { User } from "../../generated-axios-client";

type UsersState = {
  technicians: User[];
  loading: boolean;
  error: string | null;
};

export function useDashboardUsers(): UsersState {
  const technicians = useSelector((state: RootState) => state.dashboard.technicians);
  const loading = useSelector((state: RootState) => state.dashboard.loading);
  const error = useSelector((state: RootState) => state.dashboard.error);
  return { technicians, loading, error };
}
